import React from "react";

const IconLeftCaret = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={9}
      height={13}
      viewBox="0 0 9 13"
      fill="none"
      {...props}
    >
      <path
        d="M8.05192 1.07499L6.99092 0.014986L1.21192 5.79199C1.11876 5.88455 1.04484 5.99463 0.994388 6.11588C0.94394 6.23713 0.917969 6.36716 0.917969 6.49849C0.917969 6.62981 0.94394 6.75984 0.994388 6.88109C1.04484 7.00234 1.11876 7.11242 1.21192 7.20499L6.99092 12.985L8.05092 11.925L2.62692 6.49999L8.05192 1.07499Z"
        fill="#FDF2DE"
      />
    </svg>
  );
};

export default IconLeftCaret;
